import type { Component } from 'vue'
import ContentCard from '../../components/molecules/ContentCard/ContentCard.vue'
import ContentGroup from '../../components/organisms/ContentGroup/ContentGroup.vue'
import ContentCarousel from '../organisms/ContentCarousel/ContentCarousel.vue'
import InfoStrip from '../organisms/InfoStrip/InfoStrip.vue'
import RankedList from '../organisms/RankedList/RankedList.vue'
import GamesList from '../organisms/GamesList/GamesList.vue'
import HeroShowcase from '../organisms/HeroShowcase/HeroShowcase.vue'
import FeedList from '../organisms/FeedList/FeedList.vue'
import ExploreMore from '../organisms/ExploreMore/ExploreMore.vue'

/**
 * Maps layout-config component names to actual Vue components.
 * Extend this map as new organisms/molecules are registered.
 */
export const componentRegistry = new Map<string, Component>([
  ['ContentCard', ContentCard],
  ['ContentGroup', ContentGroup],
  ['ContentCarousel', ContentCarousel],
  ['InfoStrip', InfoStrip],
  ['RankedList', RankedList],
  ['GamesList', GamesList],
  ['HeroShowcase', HeroShowcase],
  ['FeedList', FeedList],
  ['ExploreMore', ExploreMore],
])

export function resolveRegisteredComponent(
  name: string
): Component | undefined {
  return componentRegistry.get(name)
}

export function getRegisteredComponentNames(): string[] {
  return Array.from(componentRegistry.keys())
}

/**
 * Register a component at runtime (e.g., from a plugin). Mirrors
 * registerTemplate: this is how upper layers (common) contribute smart,
 * data-coupled components to config-driven layouts without lego-land
 * depending on them.
 */
export function registerComponent(name: string, component: Component): void {
  if (import.meta.dev && componentRegistry.has(name)) {
    console.warn(
      `registerComponent: overwriting existing component registration for name "${name}".`
    )
  }
  componentRegistry.set(name, component)
}
